import { HashRouter, Route, Routes } from 'react-router';
import bookingFlowRoutes from '~/routes/bookingFlow';
import BookingFlowOverviewProvider from '~/context/BookingFlowOverviewProvider';
import BookingFlowInformationProvider from '~/context/BookingFlowInformationProvider';
import BookingFlowSummaryProvider from '~/context/BookingFlowSummaryProvider';
import BookingFlowOverview from './BookingFlow/Steps/Overview';
import BookingFlowInformation from './BookingFlow/Steps/Information';
import BookingFlowSummary from './BookingFlow/Steps/Summary';
import BookingFlowThanks from './BookingFlow/Steps/Thanks';

export default function BookingFlow() {
  return (
    <HashRouter>
      <Routes>
        <Route
          index
          path={bookingFlowRoutes.OVERVIEW}
          element={(
            <BookingFlowOverviewProvider>
              <BookingFlowOverview />
            </BookingFlowOverviewProvider>
          )}
        />
        <Route
          path={bookingFlowRoutes.INFORMATION}
          element={(
            <BookingFlowInformationProvider>
              <BookingFlowInformation />
            </BookingFlowInformationProvider>
          )}
        />
        <Route
          path={bookingFlowRoutes.SUMMARY}
          element={(
            <BookingFlowSummaryProvider>
              <BookingFlowSummary />
            </BookingFlowSummaryProvider>
          )}
        />
        <Route
          path={bookingFlowRoutes.THANKS}
          element={<BookingFlowThanks />}
        />
      </Routes>
    </HashRouter>
  );
}
